import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/LillyFamilyIllustration.tsx
const LillyFamilyIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "lilly-family.svg",
		alt: t("illustration.imageAlt.family")
	});
};

//#endregion
export { LillyFamilyIllustration };